import { render } from "./EventHeader.vue?vue&type=template&id=9edc14d6&scoped=true"
import script from "./EventHeader.vue?vue&type=script&lang=js"
export * from "./EventHeader.vue?vue&type=script&lang=js"

import "./EventHeader.vue?vue&type=style&index=0&id=9edc14d6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9edc14d6"]])

export default __exports__